import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser'
import { ModalDirective } from 'ngx-bootstrap/modal';
import { ModalConfig } from './modal-config';

@Component({
  selector: 'modal-edit-component',
  templateUrl: './modal.edit.component.html',
  styleUrls: [ './modal.component.scss' ]
})
export class ModalEditComponent {

  @ViewChild('modalEditComponent') readonly modal: ModalDirective;
  @Output('accept') readonly onAccept = new EventEmitter<any>();
  @Output('resubmit') readonly onResubmit = new EventEmitter<any>();
  @Output('addEditProp') readonly onAddEditProperty = new EventEmitter<any>();
  @Input('data') readonly templateConfig: ModalConfig;
  @Input() readonly title: string;
  @Input() injectProperty: boolean;
  @Input() readonly content: SafeHtml;
  public config: ModalConfig = {
    backdrop: 'static',
    keyboard: false,
    focus: false,
    show: false,
    ignoreBackdropClick: true,
    small: false,
    resizeOrClose: 'resize',
    okBtnTitle: 'Cancel',
    okBtnAutoHide: true,
    okBtnCssClass: '',
    resubmitBtnTitle: '',
    resubmitBtnAutoHide: true,
    resubmitBtnCssClass: '',
  };
  public payload: any;


  public accept(): void {
    this.onAccept.emit(this.payload);
    if(this.config.okBtnAutoHide === true){
      this.modal.hide();
    }
  }

  public resubmit(): void {
    this.onResubmit.emit(this.payload);
    if(this.config.resubmitBtnAutoHide === true){
      this.modal.hide();
    }
  }

  addProp(completed: boolean) {
    this.injectProperty = completed;
    this.onAddEditProperty.emit(this.injectProperty);
  }

  public resubmitButtonTitle(title: string) {
    this.config.resubmitBtnTitle = title;
  }

  public open(config?: ModalConfig, payload ?: any): void {
    this._init(config, payload);
    this.modal.show();
  }
  public close(config?: ModalConfig, payload ?: any): void {
    this._init(config, payload);
    this.modal.hide();
  }

  public closeNow(config?: ModalConfig, payload ?: any): void {
    this.modal.hide();
  }

  public resize(): void {
    this.config.small = !this.config.small;
  }

  private  _init(modalConfig: ModalConfig, payload: any): void {
    const config = Object.assign(this.config, this.templateConfig, modalConfig);
    this.config = config;
    this.modal.config = config;
    this.payload = payload || null;
  }
}
